import axios from "axios";
import {
  CATEGORY_DISCOUNT_LIST_REQUEST,
  CATEGORY_DISCOUNT_LIST_SUCCESS,
  CATEGORY_DISCOUNT_LIST_FAIL,
} from "../constants/categoryDiscountConstants";

export const listCategoryDiscounts = () => async (dispatch) => {
  try {
    dispatch({ type: CATEGORY_DISCOUNT_LIST_REQUEST });

    // PUBLIC request – no token needed
    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/api/category-discounts`
    );

    dispatch({ type: CATEGORY_DISCOUNT_LIST_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: CATEGORY_DISCOUNT_LIST_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};
